export default __webpack_public_path__ + "locales/ro/Notifications.json?hash=50eede986a5436ecb62dbfef0e763d3e";